function cov_2n7euq9x3c() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/Layout.tsx";
  var hash = "21d88409e17bd0ef1266f7f3f0928f648f411bec";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/Layout.tsx",
    statementMap: {
      "0": {
        start: {
          line: 35,
          column: 48
        },
        end: {
          line: 40,
          column: 3
        }
      },
      "1": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 18
        }
      },
      "2": {
        start: {
          line: 53,
          column: 19
        },
        end: {
          line: 53,
          column: 60
        }
      },
      "3": {
        start: {
          line: 54,
          column: 19
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "4": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 73,
          column: 6
        }
      },
      "5": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "6": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 68
        }
      },
      "7": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 30
        }
      },
      "8": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 23
        }
      },
      "9": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 14
        }
      },
      "10": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 156,
          column: 5
        }
      },
      "11": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 107,
          column: 10
        }
      },
      "12": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 119,
          column: 10
        }
      },
      "13": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 129,
          column: 10
        }
      },
      "14": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 139,
          column: 10
        }
      },
      "15": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 151,
          column: 10
        }
      },
      "16": {
        start: {
          line: 153,
          column: 8
        },
        end: {
          line: 153,
          column: 23
        }
      },
      "17": {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 42
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 84
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 76
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 157,
            column: 3
          }
        },
        line: 96
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 23
          },
          end: {
            line: 69,
            column: 78
          }
        }, {
          start: {
            line: 69,
            column: 81
          },
          end: {
            line: 69,
            column: 87
          }
        }],
        line: 69
      },
      "1": {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 79,
            column: 68
          }
        }, {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 81,
            column: 30
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 83,
            column: 23
          }
        }, {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 85,
            column: 14
          }
        }],
        line: 77
      },
      "2": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 98,
            column: 6
          },
          end: {
            line: 107,
            column: 10
          }
        }, {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 119,
            column: 10
          }
        }, {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 129,
            column: 10
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 139,
            column: 10
          }
        }, {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 151,
            column: 10
          }
        }, {
          start: {
            line: 152,
            column: 6
          },
          end: {
            line: 153,
            column: 23
          }
        }, {
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 155,
            column: 14
          }
        }],
        line: 97
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "21d88409e17bd0ef1266f7f3f0928f648f411bec"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2n7euq9x3c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2n7euq9x3c();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function () { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import classNames from 'classnames';
import Footer from "./Footer.mjs";
import FooterFull from "./FooterFull.mjs";
import Header from "./Header.mjs";
import "./LayoutStyle.css";
/** @deprecated */
let Layout = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Layout, _React$PureComponent);
  function Layout() {
    _classCallCheck(this, Layout);
    return _callSuper(this, Layout, arguments);
  }
  _createClass(Layout, [{
    key: "render",
    value: function render() {
      cov_2n7euq9x3c().f[0]++;
      const {
        analyticsName,
        fixedHeader,
        footerType,
        headerType,
        hideHeaderMobile,
        renderAccountMenu,
        renderExtra,
        renderLogo
      } = (cov_2n7euq9x3c().s[1]++, this.props);
      const footer = (cov_2n7euq9x3c().s[2]++, this.getFooter(analyticsName, footerType));
      const header = (cov_2n7euq9x3c().s[3]++, this.getHeader(analyticsName, headerType, hideHeaderMobile, renderAccountMenu, renderLogo, renderExtra));
      cov_2n7euq9x3c().s[4]++;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('od-layout light-theme light-theme-mobile', {
          'od-layout--with-fixed-header': fixedHeader
        })
      }, fixedHeader ? (cov_2n7euq9x3c().b[0][0]++, /*#__PURE__*/React.createElement("div", {
        className: "od-layout__fixed-header"
      }, header)) : (cov_2n7euq9x3c().b[0][1]++, header), /*#__PURE__*/React.createElement("main", null, this.props.children), footer);
    }
  }, {
    key: "getFooter",
    value: function getFooter(analyticsName, footerType) {
      cov_2n7euq9x3c().f[1]++;
      cov_2n7euq9x3c().s[5]++;
      switch (footerType) {
        case 'MINIMAL':
          cov_2n7euq9x3c().b[1][0]++;
          cov_2n7euq9x3c().s[6]++;
          return /*#__PURE__*/React.createElement(Footer, {
            analyticsName: "".concat(analyticsName, "-footer")
          });
        case 'FULL':
          cov_2n7euq9x3c().b[1][1]++;
          cov_2n7euq9x3c().s[7]++;
          return /*#__PURE__*/React.createElement(FooterFull, null);
        case 'NONE':
          cov_2n7euq9x3c().b[1][2]++;
          cov_2n7euq9x3c().s[8]++;
          return /*#__PURE__*/React.createElement("div", null);
        default:
          cov_2n7euq9x3c().b[1][3]++;
          cov_2n7euq9x3c().s[9]++;
          break;
      }
    }
  }, {
    key: "getHeader",
    value: function getHeader(analyticsName, headerType, hideHeaderMobile, renderAccountMenu, renderLogo, renderExtra) {
      cov_2n7euq9x3c().f[2]++;
      cov_2n7euq9x3c().s[10]++;
      switch (headerType) {
        case 'FULL':
          cov_2n7euq9x3c().b[2][0]++;
          cov_2n7euq9x3c().s[11]++;
          return /*#__PURE__*/React.createElement(Header, {
            analyticsName: "".concat(analyticsName, "-header"),
            hiddenMobile: hideHeaderMobile,
            renderAccountMenu: renderAccountMenu,
            renderLogo: renderLogo,
            onBackClick: this.props.onBackClick
          });
        case 'HIDE_NAV':
          cov_2n7euq9x3c().b[2][1]++;
          cov_2n7euq9x3c().s[12]++;
          return /*#__PURE__*/React.createElement(Header, {
            analyticsName: "".concat(analyticsName, "-header"),
            hideNav: true,
            hiddenMobile: hideHeaderMobile,
            renderAccountMenu: renderAccountMenu,
            renderLogo: renderLogo,
            renderExtra: renderExtra,
            onBackClick: this.props.onBackClick
          });
        case 'MINIMAL':
          cov_2n7euq9x3c().b[2][2]++;
          cov_2n7euq9x3c().s[13]++;
          return /*#__PURE__*/React.createElement(Header, {
            analyticsName: "".concat(analyticsName, "-header"),
            hideAccount: true,
            hideNav: true,
            hiddenMobile: hideHeaderMobile,
            onBackClick: this.props.onBackClick
          });
        case 'BROKERAGE':
          cov_2n7euq9x3c().b[2][3]++;
          cov_2n7euq9x3c().s[14]++;
          return /*#__PURE__*/React.createElement(Header, {
            analyticsName: "".concat(analyticsName, "-header"),
            hideNav: true,
            hiddenMobile: hideHeaderMobile,
            showBrokerageLogo: true,
            onBackClick: this.props.onBackClick
          });
        case 'BROKERAGE_MINIMAL':
          cov_2n7euq9x3c().b[2][4]++;
          cov_2n7euq9x3c().s[15]++;
          return /*#__PURE__*/React.createElement(Header, {
            analyticsName: "".concat(analyticsName, "-header"),
            hideAccount: true,
            hideNav: true,
            hiddenMobile: hideHeaderMobile,
            hideBorder: true,
            showBrokerageLogo: true,
            onBackClick: this.props.onBackClick
          });
        case 'NONE':
          cov_2n7euq9x3c().b[2][5]++;
          cov_2n7euq9x3c().s[16]++;
          return /*#__PURE__*/React.createElement("div", null);
        default:
          cov_2n7euq9x3c().b[2][6]++;
          cov_2n7euq9x3c().s[17]++;
          break;
      }
    }
  }]);
  return Layout;
}((React.PureComponent));
_defineProperty(Layout, "defaultProps", (cov_2n7euq9x3c().s[0]++, {
  fixedHeader: false,
  footerType: 'MINIMAL',
  headerType: 'FULL',
  hideHeaderMobile: false
}));
export { Layout as default };